import { stringifyEntityRef } from '@backstage/catalog-model';
import { LinkButton } from '@backstage/core-components';
import { useEntity } from '@backstage/plugin-catalog-react';
import AccountTreeIcon from '@material-ui/icons/AccountTree';
import { ARCHITECTURE_PATH } from '../home/HomePage';

// Кнопка в заголовке карточки связей: открывает общую схему архитектуры с этой сущностью в центре.
export const ArchitectureLink = () => {
  const { entity } = useEntity();
  const ref = encodeURIComponent(stringifyEntityRef(entity));
  return (
    <LinkButton
      to={`${ARCHITECTURE_PATH}?entity=${ref}`}
      size="small"
      color="primary"
      startIcon={<AccountTreeIcon />}
    >
      На схеме
    </LinkButton>
  );
};
